import { Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

// ----------------------------------------------------------------------

export default function Logo({ disabledLink = false, width = 50, style = {} }) {
  // const logo = <img src="/logo.svg" alt="" style={{ width, ...style }} />;

  const logo = (
    <Box sx={{ width, height: width, ...style }}>
      <svg id="Path" xmlns="http://www.w3.org/2000/svg" width={width} height={width} viewBox="0 0 72 84">
        <path
          id="Path-2"
          data-name="Path"
          d="M0,20.835v9.26L32.037,11.906v69.78L36,84l3.963-2.315V11.906L72,30.094v-9.26L36,0Z"
          fill="#6152f1"
        />
        <path
          id="Combined_Shape"
          data-name="Combined Shape"
          d="M28,60v0h0l-7-3.955V40.879L7.333,33.3V47.472L0,43.517V15.494L28,0V60ZM20.667,13.187l-13,6.923v4.616l13,7.582V13.187Z"
          transform="translate(0 20)"
          fill="#6152f1"
        />
        <path
          id="Combined_Shape-2"
          data-name="Combined Shape"
          d="M0,60V0L28,15.824V44.176L0,60ZM7.333,34.285V47.143L20,40.879V34.285Zm0-21.1V26.374H20V19.78Z"
          transform="translate(44 20)"
          fill="#6152f1"
        />
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="/">{logo}</RouterLink>;
}
